import { render } from "./EditingMediaUnknown.vue?vue&type=template&id=7ecc932a"
const script = {}
script.render = render

export default script